export default {
  payouts: {
    overview: {
      title: 'Overview',
      seeMyPayoutBalance: 'See my payout balance',
    },
    pending: {
      title: 'Things that are pending',
      tooltip: 'These are things that have been authorized, but haven\'t yet been initiated or transferred.',
      transactionsHtml: 'Transactions %{spanOpen} in {{currency}}%{spanClose}',
      balanceHtml: 'Balance %{spanOpen}in {{currency}}%{spanClose}',
    },
    walletBalance: {
      title: 'Wallet Balance',
      tooltip: 'This is the amount of spendable cash you have in your Reverb Wallet, including gift cards and other credits in USD. Wallet balances are only valid for use on Reverb.com and cannot be redeemed for cash or transferred to a bank.',
    },
    payoutMethod: {
      missing: 'Provide your {{children}} so you can get paid.',
      bankInformation: 'bank information',
      achHtml: 'Your earnings will automatically be deposited into your %{strongOpen}Bank Account ending in {{bankAccountNumber}}.%{strongClose}',
      managePayoutSettings: 'Manage payout settings',
      walletHtml: 'Your earnings are instantly added to your %{strongOpen}Reverb Wallet.%{strongClose}',
      editHowYouGetPaid: 'Edit how you get paid',
      paypalHtml: 'Your earnings are transferred to your linked %{strongOpen}PayPal account.%{strongClose}',
    },
    walletMarketing: {
      content_html: 'Faster cash. Lower %{break}fees. Zero hassle.%{break}%{strongOpen}Use Reverb Wallet%{strongClose}',
    },
    history: {
      title: 'Payout History',
    },
  },
};
